import { render, staticRenderFns } from "./addPodcast.vue?vue&type=template&id=08c5a244"
import script from "./addPodcast.vue?vue&type=script&lang=js"
export * from "./addPodcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports